import Raven from 'raven-js'
import { createFetch, accept, header, init, debug, recv } from 'http-client'
import { graphqlUrl } from 'lib/path-helpers'
import { DEFAULT_TIMEZONE } from './utils/moment'

interface Options {
  accept?: string
  contentType?: string
  credentials?: string
  method?: string
  body?: string | null
  headers?: Headers
}

const defaultRequest = (url: string, options: Options = {}): Promise<globalThis.Response> => {
  const request = createFetch(
    accept(options.accept || 'application/json'),
    header('x-requested-with', 'fetch'),
    header('content-type', options.contentType || 'application/json'),
    header('x-timezone', DEFAULT_TIMEZONE),
    init('credentials', options.credentials || 'include'),
    debug(),
    recv(response => {
      if (response.debug) {
        response.requestInfo = sanitizeDebugInfo(response.debug)
        delete response.debug
      }

      return response
    })
  )

  return request(url, options).catch(err => {
    const fullStoryURL = getFullStory()
    let requestInfo

    if (err.debug) {
      requestInfo = sanitizeDebugInfo(err.debug)
      err.requestInfo = requestInfo
      delete err.debug
    }

    Raven.setExtraContext({
      fullStoryURL,
      requestInfo
    })

    throw err
  })
}

export const jsonRequest = (url, options = {}) => {
  return defaultRequest(url, options).then(async res => {
    if (!res.ok && res.status !== 307) {
      throw new Error('Non 2xx status code')
    }
    return res
  })
}

function getFullStory() {
  const fullstory = (window as any).FS
  if (!fullstory || typeof fullstory.getCurrentSessionURL !== 'function') {
    return
  }

  return fullstory.getCurrentSessionURL(true)
}

function sanitizeDebugInfo(debugInfo) {
  const sanitized = {
    input: debugInfo.input,
    method: debugInfo.options.method,
    operationName: undefined
  }

  // We only care about grabbing the `operationName`, which gives us enough insight into the call site
  if (debugInfo.input === graphqlUrl()) {
    const body = JSON.parse(debugInfo.options.body)
    sanitized.operationName = body.operationName
  }

  return sanitized
}

export default defaultRequest
